// @flow
import React from 'react'
import { Box, boxProps } from 'frack-components'

type Props = boxProps

const Article = (props: Props) => <Box {...props} />

Article.defaultProps = {
  tag: 'article',
}

export default Article
